import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // Swiper styles
import { ArrowRight } from 'lucide-react';
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import AOS from 'aos';
import 'aos/dist/aos.css'; 

const testimonials = [
  {
    name: "Ahmet G.",
    role: "Event Manager",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    text: "It is the best tool for leads collection. During my events I share QR Code on the screen and attendees scan it and fill in the answers, it enables me to reach them out after the event.",
    rating: 5,
  },
  {
    name: "Allen W.",
    role: "Event Organizer",
    image: "https://randomuser.me/api/portraits/men/2.jpg",
    text: "Very easy to register names and manual payments without the need of the complex system, I have my team working on it smoothly.",
    rating: 5,
  },
  {
    name: "Deniz S.",
    role: "Exhibitor",
    image: "https://randomuser.me/api/portraits/women/3.jpg",
    text: "With LiveQR, I was able to know who was interested and drop by my booth during the exhibition. I use it every time we have a stand.",
    rating: 5,
  },
  {
    name: "Maria L.",
    role: "Marketing Director",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    text: "LiveQR helped us engage with our audience at trade shows like never before. We collected high-quality leads in minutes!",
    rating: 5,
  },
  {
    name: "John T.",
    role: "Startup Founder",
    image: "https://randomuser.me/api/portraits/men/55.jpg",
    text: "This tool simplified our lead capture process at pitch events. No more printed forms or missed contacts!",
    rating: 4,
  },
  {
    name: "Fatima R.",
    role: "Conference Host",
    image: "https://randomuser.me/api/portraits/women/66.jpg",
    text: "Managing attendee information used to be a hassle—now it’s seamless thanks to LiveQR’s smart QR registration.",
    rating: 5,
  },
];

export default function Aboutus() {





  useEffect(() => {
    AOS.init({
      duration: 800, 
      once: true,
      offset: 100, 
    });
  }, []);

  

  return (
    <>
      {/* Section 1: Hero */}
      <section className="flex flex-col" data-aos="fade-up">
        <div className="flex-grow">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-6 py-20 gap-10">
            {/* Text Section */}
            <div className="max-w-xl space-y-5" data-aos="fade-right" data-aos-delay="100">
              <h2 className="text-[69px] font-bold text-[#234042] Bebas-neue">ABOUT US</h2>
              <div className="flex items-center space-x-2 text-lg Bebas-neue">
                <span className="text-[#234042]">HOME</span>
                <span className="h-4 w-[1px] bg-gray-400 mx-1"></span>
                <span className="text-[#F47321] tracking-light">ABOUT US</span>
              </div>
              <p className="text-[#234042] text-[20px] leading-relaxed helvetica-neue">
                We're redefining how people connect with digital content through smart, dynamic QR code solutions. Our mission is to make sharing, tracking, and engaging with information easier, faster, and more interactive than ever.
              </p>
            </div>
            {/* Image */}
            <div className="relative" data-aos="zoom-in" data-aos-delay="200">
              <LazyLoad height={400} offset={50} once>
                <img
                  src="/images/about.png"
                  alt="LiveQR process illustration"
                  className="w-full max-w-[604px]"
                />
              </LazyLoad>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Who We Are */}
      <section className="bg-white pb-20" data-aos="fade-up" data-aos-delay="100">
        <div className="max-w-7xl mx-auto px-6 space-y-5">
          <h2 className="text-[#F47321] text-[30px] uppercase Bebas-neue">Live QR</h2>
          <h1 className="text-[75px] font-bold text-[#234042] Bebas-neue">WHO WE ARE</h1>
          <h3 className="text-[#F47321] text-[30px] font-semibold uppercase tracking-wide Bebas-neue">
            They Scan. You Collect.
          </h3>
          <p className="text-[#234042] text-[18px] max-w-7xl helvetica-neue font-light">
            At LiveQR, we are passionate about revolutionizing the way events are managed and experienced. With our cutting-edge technology and innovative solutions, we empower event organizers to create seamless and engaging experiences for their attendees.
          </p>
          <div className="grid lg:grid-cols-3 grid-cols-1 gap-6">
            {/* Paragraph section */}
            <p className="text-[#234042] text-[18px] helvetica-neue font-light max-w-6xl col-span-1 lg:col-span-2 order-1 lg:order-2" data-aos="fade-right" data-aos-delay="200">
              LiveQR was born out of the market’s need for a centralized solution that boosts attendee engagement. Our state-of-the-art QR code generators empower event managers to easily create customized QR codes. With LiveQR, event managers can streamline check-ins and enrich event experiences, eliminating delays and paperwork, while enhancing attendee satisfaction. We are here to revolutionize events outcomes and deliver memorable experiences.
              <br /><br />
              By utilizing our LiveQR platform, marketing teams can easily create and distribute QR Codes across various locations, allowing attendees to scan and fill out information conveniently. This process eliminates the need for tedious paperwork, speeds up the check-in process, and ensures accurate and efficient data collection.
              <br /><br />
              We understand that privacy and data security are paramount concerns in today’s digital landscape. Therefore, LiveQR prioritizes the protection of personal information. Our platform adheres to stringent data protection standards, ensuring that attendee data remains secure and confidential.
              <br /><br />
              While we're proud of the expertise and technology behind LiveQR, we choose to keep specific company information confidential to focus on providing exceptional event management solutions and protecting the privacy of our clients.
              <br /><br />
              We believe that every event is unique and deserves a tailored approach. That's why LiveQR offers a flexible and customizable solution that caters to the diverse needs of event managers across various industries. Whether you're organizing a conference, an exhibition, trade show, concert, or any other event, LiveQR is here to simplify your event management process and enhance attendee experiences.
            </p>
            {/* Vision Card */}
            <div className="relative overflow-hidden bg-[#234042] text-white rounded-[26px] col-span-1 flex flex-col justify-center order-2 lg:order-1" data-aos="zoom-in" data-aos-delay="300">
              <div
                className="absolute inset-0 bg-cover bg-center opacity-10"
                style={{ backgroundImage: "url('/images/about2.png')" }}
              />
              <div className="relative z-10 py-16 px-10  lg:px-[50px]">
                <div className="text-[#F47321] text-lg lg:text-[30px] uppercase Bebas-neue mb-4">
                  Our Vision
                </div>
                <div>
                  <p className="text-md text-lg helvetica-neue text-white">
                    Is to become the go-to destination for event organizers looking to create exceptional events, and we are
                    constantly working to improve and expand our platform and services to meet the needs of our users.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <p className="text-[#234042] text-[18px] max-w-6xl helvetica-neue font-light" data-aos="fade-up" data-aos-delay="400">
            Join the growing community of event professionals who trust LiveQR for their event management needs. Let us help you unlock the full potential of your events and create memorable experiences that leave a lasting impact.
          </p>
          <div className="grid lg:grid-cols-3 grid-cols-1 gap-6">
            <div className="col-span-2" data-aos="fade-right" data-aos-delay="200">
              <p className="text-[#234042] text-[18px] helvetica-neue font-light max-w-6xl">
                Get in touch with our team to learn more about how LiveQR can elevate your event marketing game. We're excited to embark on this journey with you!
              </p>
              <p className="text-[#234042] text-[30px] font-medium mt-5">
                THEY SCAN, YOU COLLECT! ORGANIZE WHAT YOU COLLECT
              </p>
              <button
                className="bg-[#F47321] hover:bg-[#d75d0b] text-white rounded-none mt-5 flex items-center gap-2 transition transform scale-y-125 text-md lg:text-[18px] lg:px-4 lg:py-3 px-2 py-2 btn-hover-effect"
                data-aos="fade-up" data-aos-delay="300"
              >
                <span>Get Started</span>
                <span className="icon-arrow-right">
                  <ArrowRight className="w-4 h-4" />
                </span>
              </button>
            </div>
            {/* Mission Card */}
            <div className="relative overflow-hidden py-16 px-10  lg:px-10 bg-[#234042] text-white rounded-[26px] col-span-1 flex flex-col justify-center order-1" data-aos="zoom-in" data-aos-delay="400">
              <div
                className="absolute inset-0 bg-cover bg-center opacity-10"
                style={{ backgroundImage: "url('/images/about1.png')" }}
              />

              <div className="relative z-10  ">
                <div className="text-[#F47321] text-lg lg:text-[30px] uppercase Bebas-neue mb-4">
                  Our Mission
                </div>
              </div>
              <div className="">
                <p className="text-md text-[18px] helvetica-neue text-white">
                  Our mission is to make it easy for event organizers to collect data from their events. We believe that by providing a
                  simple and efficient way to collect this data, event organizers will be able to better understand their
                  audience and improve the overall event experience.
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Section 3: CTA */}
      <div
        className="bg-cover bg-center text-white py-20 bg-[#234042]"
        style={{ backgroundImage: "url('/images/Clip.png')" }}
        data-aos="fade-up" data-aos-delay="100"
      >
        <div className="text-center mx-auto px-4 max-w-7xl">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 sm:gap-10">
            <h1 className="text-4xl lg:text-[75px] font-bold uppercase text-left leading-tight sm:leading-tight Bebas-neue text-white" data-aos="fade-right" data-aos-delay="200">
              They Scan, You Collect! <br />
              Organize what you Collect!
            </h1>
            <button
              type="button"
              className="bg-white text-black hover:bg-white rounded-none uppercase flex items-center gap-2 whitespace-nowrap border border-gray-300 transition transform scale-y-125 text-md lg:text-[18px] lg:pl-4 lg:pr-10 lg:py-3 px-2 py-2 btn-hover-white"
              data-aos="fade-left" data-aos-delay="300"
            >
              <span>GET STARTED</span>
              <span className="icon-arrow-right">
                <ArrowRight className="w-4 h-4" />
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Section 4: Testimonials */}
      <section className="bg-white text-center lg:py-[100px] pt-[100px] pb-20" data-aos="fade-up" data-aos-delay="100">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-start md:items-center mb-8 space-y-4 md:space-y-0 md:space-x-20">
          <h2 className="text-2xl md:text-4xl font-bold text-[#234042] whitespace-nowrap uppercase Bebas-neue" data-aos="fade-right" data-aos-delay="200">
            TESTIMONIALS
          </h2>
          <p className="text-[#234042] text-left text-md flex-1 helvetica-neue" data-aos="fade-left" data-aos-delay="300">
            Don’t just take our word for it—see what our customers are saying about their experience with LiveQR. From businesses to individuals, our users share how LiveQR has made a real difference in the way they connect and engage.
          </p>
        </div>
        <div className="max-w-7xl mx-auto px-4">
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={30}
            slidesPerView={1}
            centeredSlides={true}
            loop={true}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            pagination={{ clickable: true, el: '.swiper-pagination-testimonials' }}
            navigation={{
              nextEl: '.swiper-button-next-testimonials',
              prevEl: '.swiper-button-prev-testimonials',
              hiddenClass: 'swiper-button-hidden',
              disabledClass: 'swiper-button-disabled',
            }}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="relative"
          >
            {testimonials.map((t, idx) => (
              <SwiperSlide key={idx} className="flex justify-center">
                <div className="helvetica-neue w-full max-w-sm shadow-md  h-full min-h-[360px] bg-white p-6 flex flex-col justify-between relative overflow-hidden transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-xl group" data-aos="zoom-in" data-aos-delay={`${idx * 100}`}>

                  <span className="absolute left-0 top-0 h-0 w-0 border-t-2 border-transparent transition-all duration-500 group-hover:w-full" style={{ borderImage: 'linear-gradient(to right, #234042, #156E77) 1' }}></span>
                  <span className="absolute right-0 top-0 h-0 w-0 border-r-2 border-transparent transition-all duration-500 group-hover:h-full" style={{ borderImage: 'linear-gradient(to bottom, #234042, #156E77) 1' }}></span>
                  <span className="absolute bottom-0 right-0 h-0 w-0 border-b-2 border-transparent transition-all duration-500 group-hover:w-full" style={{ borderImage: 'linear-gradient(to left, #234042, #156E77) 1' }}></span>
                  <span className="absolute bottom-0 left-0 h-0 w-0 border-l-2 border-transparent transition-all duration-500 group-hover:h-full" style={{ borderImage: 'linear-gradient(to top, #234042, #156E77) 1' }}></span>

                  <div className="flex-1 relative z-10">
                    <p className="Helvetica Neue text-left text-[#888888] !text-xl mb-4 space-x-3 font-light">
                      “{t.text}”
                    </p>
                  </div>
                  <div className="flex items-center mt-4 relative z-10">
                    <img
                      src={t.image}
                      alt={t.name}
                      className="w-[80px] h-[80px] rounded-full border-2 border-white shadow-md mr-4 transform transition-transform duration-300 group-hover:scale-110"
                    />
                    <div className="text-left">
                      <h4 className="text-gray-900 text-[20px] font-bold">{t.name}</h4>
                      <p className="text-sm text-[13px] font-light text-[#515151]">{t.role}</p>
                      <div className="flex mt-2">
                        {Array.from({ length: t.rating }).map((_, i) => (
                          <span key={i} className="text-orange-500 text-xl transition-transform duration-300 group-hover:scale-125">★</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
            <div className="swiper-button-prev-testimonials md:hidden text-white bg-[#234042] rounded-full w-10 h-10 flex items-center justify-center absolute left-2 top-1/2 transform -translate-y-1/2 z-10">
              <ArrowRight className="w-6 h-6 rotate-180" />
            </div>
            <div className="swiper-button-next-testimonials md:hidden text-white bg-[#234042] rounded-full w-10 h-10 flex items-center justify-center absolute right-2 top-1/2 transform -translate-y-1/2 z-10">
              <ArrowRight className="w-6 h-6" />
            </div>
            <div className="swiper-pagination-testimonials mt-4"></div>
          </Swiper>
        </div>
      </section>

      {/* Section 5: Contact CTA */}
      <div className="bg-[#156E77] text-white py-20 px-4 sm:px-10" data-aos="fade-up" data-aos-delay="100">
        <div className="flex flex-col md:flex-row max-w-7xl mx-auto items-start lg:items-center lg:justify-between gap-4">
          <p className="lg:text-5xl text-4xl text-left lg:text-center md:text-left Bebas-neue" data-aos="fade-right" data-aos-delay="200">
            WANT TO SEND YOUR OWN REVIEWS? SEND US A MESSAGE!
          </p>
          <div className="flex justify-center md:justify-start" data-aos="fade-left" data-aos-delay="300">
            <Link
              to="/contact-us"
              className="uppercase flex items-center gap-2 bg-white text-[#1C1D21] transition transform scale-y-125 text-xs lg:text-[18px] lg:px-4 lg:py-3 px-2 py-2 rounded-none hover:bg-gray-100 oswald btn-hover-white"
            >
              <span>CONTACT US</span>
              <span className="icon-arrow-right">
                <ArrowRight className="w-4 h-4 transition-opacity duration-200" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}